<template>
  <div>
    <Main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :isVc="isVc"
      @reload="getData"
      @set-scm-fba="setScmFba"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <div slot="toolbar" class="table_toolbar">
        <div class="d-flex">
          <SearchTabs
            ref="searchTabs"
            :amzReplenishmentCode="amzReplenishmentCode"
            @change="getData"
          />
          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="setfba-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="setRowsScmFba"
            >
              {{ $l('form_label_backfilling_FBA') || '回填FBA信息' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </div>
        <div class="toolbar_tools">
          <vxe-button circle>
            <i class="vxe-icon--search" @click="advquery()" />
          </vxe-button>
        </div>
      </div>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </Main>

    <SearchForm
      ref="header"
      :visible.sync="advqueryVisible"
      :isVc="isVc"
      @query="getData"
    />

    <SetScmFba
      :visible.sync="setScmFbaOpts.visible"
      :data="setScmFbaOpts.data"
      @reload="getData"
    />
  </div>
</template>
<script>
import Main from './main'
import SearchTabs from './search-tabs'
import SearchForm from './search-form'
import SetScmFba from '../set-scm-fba'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { Main, SearchTabs, SearchForm, SetScmFba },
  props: {
    amzReplenishmentCode: { type: String, default: '' },
    isVc: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      advqueryVisible: false,
      skuDetailOpts: { visible: false, amzReplenishmentDetailCode: '' },
      checkedRows: [],
      setScmFbaOpts: { visible: false, data: [] },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzReplenishmentCode) return

      const form = this.$refs.header.form
      const restockStatus = this.$refs.searchTabs.restockStatus
      const params = {
        ...form,
        ...this.page,
        amzReplenishmentCode: this.amzReplenishmentCode,
        restockStatus,
      }
      this.loading = true
      this.$api
        .ecomAmzReplenishmentDetailListByScmFbaApi(params)
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    advquery() {
      this.advqueryVisible = true
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    setRowsScmFba() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l('tips_setRowsFbaEmpty'),
          type: 'warning',
        })
        return
      }
      this.setScmFbaOpts = { visible: true, data: [...this.checkedRows] }
    },
    setScmFba(row) {
      this.setScmFbaOpts = { visible: true, data: [row] }
    },
  },
}
</script>
<style lang="scss" scoped>
.table_toolbar {
  display: flex;
  justify-content: space-between;
  .toolbar_tools {
    display: flex;
    align-items: center;
    margin-right: 12px;
    .vxe-button--content {
      i {
        font-size: 13px;
      }
    }
  }
}
.setfba-button {
  .el-icon-circle-close {
    display: none;
  }
}
.setfba-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
